import { __decorate, __metadata } from "tslib";
import { Serialize } from '@ftr/serialization';
import { LocalDateTime } from '@js-joda/core';
import { IsEnum, IsNumber, IsOptional, IsString, IsUUID } from 'class-validator';
import { LiveSttResultStatus } from './LiveSttResultStatus';
/**
 * Live streaming STT result, this is basically the streaming version of Remark.
 * The fields have been purposely made very similar to simplify type
 * consolidation/merging in the future.
 */
export class LiveSttResult {
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], LiveSttResult.prototype, "id", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], LiveSttResult.prototype, "sequenceNumber", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", LocalDateTime
    /**
     * This is optional because unlike remarks, we don't know when a streaming STT
     * result will end.
     */
    )
], LiveSttResult.prototype, "startTime", void 0);
__decorate([
    IsOptional(),
    Serialize(() => LocalDateTime),
    __metadata("design:type", LocalDateTime)
], LiveSttResult.prototype, "endTime", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], LiveSttResult.prototype, "speakerId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], LiveSttResult.prototype, "speakerName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], LiveSttResult.prototype, "content", void 0);
__decorate([
    IsEnum(LiveSttResultStatus),
    __metadata("design:type", String)
], LiveSttResult.prototype, "status", void 0);
